// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".SH8fSUCvTD0QIWlBu0ma{position:fixed;top:0;width:100vw;height:100vh;z-index:99999;display:flex;flex-direction:column}.DCRhQnhq5jusOVGSRekS{position:absolute;top:16px;left:16px;width:24px;height:24px;z-index:999999}.GtBMx_Zo2QCvQ4hGSVjI{display:none}.M5xMlSaMghVNXWFshud7{background:rgba(0,0,0,.5)}.kTDh5tzhMnRPUj4SPpWN{flex-grow:1}.tbuIs1yX9Noix7Cq228p{display:flex}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"layer": "SH8fSUCvTD0QIWlBu0ma",
	"close": "DCRhQnhq5jusOVGSRekS",
	"hidden": "GtBMx_Zo2QCvQ4hGSVjI",
	"block": "M5xMlSaMghVNXWFshud7",
	"flexBlock": "kTDh5tzhMnRPUj4SPpWN",
	"row": "tbuIs1yX9Noix7Cq228p"
};
export default ___CSS_LOADER_EXPORT___;
